import { IRootState } from 'app/shared/reducers';
import { createSelector, Selector } from 'reselect';
import { CmsState } from './cms-state';

const selectCmsState: any = (state: IRootState) => state.cms;

export const getContent = (contentType: string) => createSelector(selectCmsState, (cms: CmsState) => cms.content[contentType]);

export const getMarketingContent = (contentType: string) =>
  createSelector(selectCmsState, (cms: CmsState) => cms.marketing.marketingItems[contentType]);
